import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function SponsorAds({ ads = [] }) {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4500,
    adaptiveHeight: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    vertical: true,
    verticalSwiping: true,
    beforeChange: function(currentSlide, nextSlide) {
      console.log("before change", currentSlide, nextSlide);
    },
    afterChange: function(currentSlide) {
      console.log("after change", currentSlide);
    }
  };

  // Separate banner and embedded ads
  const bannerAds = ads.filter((ad) => ad.type === "banner");
  const embeddedAds = ads.filter((ad) => ad.type === "embedded");

  return (
    <>
      {bannerAds.length > 0 && (
        <div
          className="card mb-3 shadow-sm"
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            border: "1px solid #e5e7eb",
          }}
        >
          <div
            className="card-header fw-semibold py-2 small"
            style={{
              background: "linear-gradient(90deg, #f8f9fa, #e9ecef)",
              borderBottom: "1px solid #dee2e6",
            }}
          >
            Sponsored
          </div>
          <div
            className="card-body p-2"
            style={{
              background: "linear-gradient(to bottom, #ffffff, #f8f9fa)",
            }}
          >

            <div className="sponsore-slider-main">
              <Slider {...settings}>
                {bannerAds.map((ad, index) => (
                  <div key={index} className="d-flex text-center h-100"
                    style={{
                      overflow: "hidden",
                      borderRadius: "8px",
                    }}
                  >
                    <a
                      href={ad.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex"
                      style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                        width: "100%",
                      }}
                    >
                      <img
                        src={ad.image}
                        alt={`Sponsor ${index + 1}`}
                        className="img-fluid"
                        style={{
                          borderRadius: "8px",
                          objectFit: "cover",
                          width: "100%",
                          height: "350px",
                          transition: "transform 0.3s ease-in-out",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.transform = "scale(1.05)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "scale(1)")
                        }
                      />
                    </a>
                  </div>
                ))}
              </Slider>
            </div>

          </div>
        </div>
      )}

      {embeddedAds.length > 0 && (
        <div
          className="card mb-3 shadow-sm"
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            border: "1px solid #e5e7eb",
          }}
        >
          <div
            className="card-header fw-semibold py-2 small"
            style={{
              background: "linear-gradient(90deg, #eeeeee, #cccccc)",
              borderBottom: "1px solid #dee2e6",
            }}
          >
            Sponsored
          </div>
          <div
            className="card-body p-0"
            style={{
              background: "linear-gradient(to bottom, #ffffff, #f2f2f2)",
            }}
          >
            <Slider {...settings}>
              {embeddedAds.map((ad, index) => (
                <div
                  key={index}
                  style={{
                    borderRadius: "0px",
                    background: "#fff",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                    marginBottom: "10px",
                    padding: "5px",
                  }}
                >
                  <div
                    className="responsive-embed"
                    dangerouslySetInnerHTML={{ __html: ad.embed_code }}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </>
  );
}
